import React from "react";
import SuspenseWrapper from "@/router/component/SuspenseWrapper";

const LeaveTypeCategory = React.lazy(() =>
  import("@/pages/leaveManagement/leaveTypeCategory/LeaveTypeCategory")
);
const LeaveGranter = React.lazy(() =>
  import("@/pages/leaveManagement/leaveGranter/LeaveGranter")
);
const EmployeeLeaveBalance = React.lazy(() =>
  import("@/pages/leaveManagement/employeeLeaveBalance/EmployeeLeaveBalance")
);
const LeaveCalenderAdmin = React.lazy(() =>
  import("@/pages/leaveManagement/leaveCalenderAdmin/LeaveCalenderAdmin")
);
const LeaveEncashmentApproval = React.lazy(() =>
  import("@/pages/leaveManagement/leaveEncashmentApproval/LeaveEncashmentApproval")
);
const LeaveBalanceImport = React.lazy(() =>
  import("@/pages/leaveManagement/leaveBalanceImport/LeaveBalanceImport")
);
const LeaveReport = React.lazy(() =>
  import("@/pages/leaveManagement/leaveReport/LeaveReport")
);
const LockAttendanceDate = React.lazy(() =>
  import("@/pages/leaveManagement/lockAttendanceDate/LockAttendanceDate")
);



const Index = [
  {
    path: "leaveTypeCategory",
    element: (
      <SuspenseWrapper>
        <LeaveTypeCategory />
      </SuspenseWrapper>
    ),
  },
  {
    path: "leaveGranter",
    element: (
      <SuspenseWrapper>
        <LeaveGranter />
      </SuspenseWrapper>
    ),
  },
  {
    path: "employeeLeaveBalance",
    element: (
      <SuspenseWrapper>
        <EmployeeLeaveBalance />
      </SuspenseWrapper>
    ),
  },
  {
    path: "leaveCalenderAdmin",
    element: (
      <SuspenseWrapper>
        <LeaveCalenderAdmin />
      </SuspenseWrapper>
    ),
  },
  {
    path: "leaveEncashmentApproval",
    element: (
      <SuspenseWrapper>
        <LeaveEncashmentApproval />
      </SuspenseWrapper>
    ),
  },
  {
    path: "leaveBalanceImport",
    element: (
      <SuspenseWrapper>
        <LeaveBalanceImport />
      </SuspenseWrapper>
    ),
  },
  {
    path: "leaveReport",
    element: (
      <SuspenseWrapper>
        <LeaveReport />
      </SuspenseWrapper>
    ),
  },
  {
    path: "lockAttendanceDate",
    element: (
      <SuspenseWrapper>
        <LockAttendanceDate />
      </SuspenseWrapper>
    ),
  },
];

export default Index;
